import { useCallback, useRef, useState } from "react";

/**
 * Prevents overlapping async mutations from double-clicks.
 * Uses a sync ref so a second click in the same tick is ignored,
 * plus busy state for disabling buttons.
 */
export function useMutationLock() {
  const inFlightRef = useRef(false);
  const [busy, setBusy] = useState(false);

  const run = useCallback(async (fn) => {
    if (inFlightRef.current) return undefined;
    inFlightRef.current = true;
    setBusy(true);
    try {
      return await fn();
    } finally {
      inFlightRef.current = false;
      setBusy(false);
    }
  }, []);

  return { busy, run };
}
